import React from 'react';

const IconJupyter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <circle cx="20" cy="24" r="10" fill="#F37726" opacity="0.9" />
    <circle cx="28" cy="24" r="10" fill="#4B77BE" opacity="0.9" />
    <circle cx="24" cy="28" r="10" fill="#5CB85C" opacity="0.9" />
    <path
      fill="#FFF"
      d="M24 20c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
    />
  </svg>
);

export default IconJupyter;
